module.exports = __webpack_public_path__ + "static/media/bjsystems.95949412.png";